<template>
  <div class="toolbar">
      <v-app-bar flat height="80" color="darkblue" app class="top-navbar pa-0">
        <v-container class="py-0 px-md-6 fill-height">
          <v-row no-gutters align="center">
            <router-link :to="{ name: 'Home' }">
              <img src="/assets/images/bw-legal-logo-inverted.svg" alt="BW Legal Logo" width="97px" height="26px" class="logo"/>
            </router-link>
            <v-toolbar-title class="ml-1 top-navbar__brand">
              {{appTitle}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <div class="hidden-md-and-down top-navbar__desktop-actions">
              <v-tabs
                background-color="transparent"
                color="transparent"
                slider-color="transparent"
                hide-slider
                class="top-navbar__tabs"
              >
                <v-tab
                  v-for="(item, index) in preServiceTabItems"
                  :key="index"
                  :to="{ name: item.route }"
                  exact
                  class="top-navbar__tab"
                >
                  {{ item.title }}
                </v-tab>

                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-tab
                      class="top-navbar__tab top-navbar__tab--menu"
                      :class="{ 'top-navbar__tab--active': isServicesActive }"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Services
                      <v-icon x-small class="nav-icon">
                        fa-chevron-down
                      </v-icon>
                    </v-tab>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in serviceMenuItems"
                      :key="`service-${index}`"
                      :to="{ name: item.route }"
                    >
                      <v-list-item-title>
                        {{ item.title }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-tab
                  v-for="(item, index) in postServiceTabItems"
                  :key="`post-${index}`"
                  :to="{ name: item.route }"
                  exact
                  class="top-navbar__tab"
                >
                  {{ item.title }}
                </v-tab>
              </v-tabs>
              <v-btn :to="{ name: 'ContactUs' }" color="primary" outlined large class="ml-4">
                Contact Us
              </v-btn>
            </div>
            <v-app-bar-nav-icon dark @click.stop="sidebar = !sidebar" class="hidden-lg-and-up" aria-label="Menu"></v-app-bar-nav-icon>
          </v-row>
        </v-container>
      </v-app-bar>
      <v-navigation-drawer
        v-model="sidebar"
        temporary
        color="darkblue"
        dark
        app
        class="hidden-lg-and-up">
        <v-list>
          <v-list-item-group color="primary">
            <div v-for="(item, index) in sidebarItems" :key="index">
              <v-list-item
                v-if="item.subLinks.length === 0"
                :to="{ name: item.route }"
                exact
                link>
                <v-list-item-icon>
                  <v-icon>{{ getNavIcon(item.route) }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-group v-else no-action :value="subLinksContainActiveRoute(item.subLinks)">
                <template v-slot:activator>
                  <v-list-item-icon>
                    <v-icon>{{ getNavIcon(item.route) }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </template>
                <v-list-item
                  v-for="(subLink, i) in item.subLinks"
                  :key="i"
                  :to="{ name: subLink.route }"
                  link>
                  <v-list-item-title v-text="subLink.title"></v-list-item-title>
                </v-list-item>
              </v-list-group>
            </div>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
  </div>
</template>

<script>
import { navMixin } from '@/mixins/navigationMixin.js';

export default {
  name: 'Navigation',
  data () {
    return {
      appTitle: 'Business',
      sidebar: null,
    };
  },
  mixins: [navMixin],
  computed: {
    preServiceTabItems () {
      let items = [
        this.routes.Home,
      ];
      return this.routesToArray(items)
    },
    postServiceTabItems () {
      let items = [
        this.routes.AboutUs,
        this.routes.Careers,
        this.routes.CustomerSite,
      ];
      return this.routesToArray(items)
    },
    serviceMenuItems () {
      return this.routesToArray(this.routes.Services.subLinks);
    },
    isServicesActive () {
      return this.activeRoute === this.routes.Services.route || this.serviceMenuItems.some(item => item.route === this.activeRoute);
    },
    sidebarItems () {
      let items = [
        this.routes.Home,
        this.routes.Services,
        this.routes.AboutUs,
        this.routes.Careers,
        this.routes.CustomerSite,
        this.routes.ContactUs
      ];
      return this.routesToArray(items)
    }
  },
  methods: {
    subLinksContainActiveRoute (subLinks) {
      return subLinks.some(x => x.route === this.activeRoute);
    }
  }
};
</script>

<style scoped>
.top-navbar__brand {
  font-weight: 500;
  color: #fff;
  font-size: 26px;
  margin-bottom: 2px;
  text-decoration: none;
}

.top-navbar .v-icon {
  color: var(--v-secondary-lighten4);
}

.top-navbar a {
  text-decoration: none;
  color: #fff;
}

.top-navbar__desktop-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
  white-space: nowrap;
}

.top-navbar__tabs {
  flex: 0 0 auto;
  width: auto;
  min-width: 0;
  align-self: center;
  display: inline-flex;
}

.top-navbar__tabs.v-tabs > .v-tabs-bar {
  background-color: transparent;
}

.top-navbar__tabs .v-tabs-bar,
.top-navbar__tabs .v-slide-group,
.top-navbar__tabs .v-slide-group__wrapper,
.top-navbar__tabs .v-slide-group__content {
  width: auto;
  flex: 0 0 auto;
}

.top-navbar__tabs .v-slide-group__content {
  justify-content: flex-end;
}

.top-navbar__tab.v-tab {
  min-width: auto;
  padding: 0 16px;
  color: #fff !important;
  font-size: 14px;
  font-weight: 500;
}

.top-navbar__tab--menu.v-tab {
  min-width: auto;
  padding: 0 16px;
}

.top-navbar__tab--menu.v-tab .v-icon {
  margin-left: 8px;
  color: inherit !important;
}

.top-navbar__tab.v-tab:before,
.top-navbar__tab.v-tab:after {
  opacity: 0 !important;
}

.top-navbar__tab.v-tab--active,
.top-navbar__tab--active {
  color: #fff;
}

.top-navbar__tab.v-tab:focus,
.top-navbar__tab.v-tab:focus-visible {
  outline: 2px solid #fff;
  outline-offset: -2px;
  border-radius: 4px;
  z-index: 1;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 28px;
}

.v-list-item__action,
.v-list-item__avatar,
.v-list-item__icon {
  display: inline-flex;
  min-width: 28px;
}

.v-item-group.v-bottom-navigation .v-btn {
  min-width: unset;
}

.v-icon.v-icon {
  width: 24px;
  font-size: 20px;
}

.nav-icon {
  width: 14px !important;
  margin-right: -4px !important;
  margin-left: 8px !important;
}

.logo {
  cursor: pointer;
  vertical-align: middle;
}

</style>
